/** Matches `mixed-${gesture}:${timestamp}:…` txn ids from canvas mixed-selection commits / undo plans. */
export function mixedGeometricOpFromHistoryTxnId(
  txnId: string | undefined
): 'move' | 'resize' | 'rotate' | undefined {
  if (!txnId) return undefined
  const m = txnId.match(/^mixed-(rotate|move|resize)(?:-panel)?:/)

  return (m?.[1] as 'move' | 'resize' | 'rotate') ?? undefined
}
